const e = {
  building_permit: "building_permit",
  fast_enquiry: "fast_enquiry",
  forced_fast_enquiry: "forced_fast_enquiry",
  full_assessment: "full_assessment"
}, E = {
  "": "",
  off_topic: "off_topic",
  new_conv: "new_conv",
  proposal_details: "proposal_details",
  lot_details: "lot_details",
  in_progress: "in_progress",
  ready_for_assessment: "ready_for_assessment",
  report_ready: "report_ready",
  amendment: "amendment",
  saved_report: "saved_report",
  sent_to_council: "sent_to_council"
}, _ = {
  NoPermitRequired: "1",
  MoreInformationRequired: "2",
  RequiresPermit: "3",
  Prohibited: "4"
}, s = {
  ASSISTANT: "ASSISTANT",
  USER: "USER"
}, S = {
  AMENDMENT: "AMENDMENT",
  CHOICES_QUESTION: "CHOICES_QUESTION",
  FINALISE_DETAILS: "FINALISE_DETAILS",
  FOLLOW_UP: "FOLLOW_UP",
  OFF_TOPIC: "OFF_TOPIC",
  OVERWRITE: "OVERWRITE",
  SITE_OVERVIEW: "SITE_OVERVIEW",
  STANDARD: "STANDARD",
  SYSTEM_ERROR: "SYSTEM_ERROR",
  TREE_DIAMETER_QUESTION: "TREE_DIAMETER_QUESTION",
  TREE_DISTANCE_QUESTION: "TREE_DISTANCE_QUESTION",
  REVIEW_PROPOSAL: "REVIEW_PROPOSAL"
}, o = {
  ADMIN: "ADMIN",
  ASSISTANT: "ASSISTANT",
  COUNCIL_USER: "COUNCIL_USER",
  END_USER: "END_USER",
  SYSTEM: "SYSTEM"
};
export {
  s as AccountType,
  _ as AssessmentLights,
  E as ConversationPhase,
  e as FlowType,
  o as GroupType,
  S as MessageType
};
//# sourceMappingURL=types.js.map
